export const FETCH_OMS_ORIGIN = 'FETCH_OMS_ORIGIN'
export const FETCH_OMS_ORIGIN_ERROR = `FETCH_OMS_ORIGIN_ERROR`
export const FETCH_OMS_ORIGIN_SUCCESS = `FETCH_OMS_ORIGIN_SUCCESS`
export const FETCH_OMS_ORIGIN_DONE = `FETCH_OMS_ORIGIN_DONE`
